var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"marginal-bottom padded-top"},[_c('h3',{staticClass:"padded-bottom padded-top StyledFont",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.title))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }